import script from "./action-call-n8n.vue?vue&type=script&setup=true&lang=js"
export * from "./action-call-n8n.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__